module.exports = __webpack_public_path__ + "da46255d508272b6a1433a608958e540.svg";